import templateUrl from 'emun.salesrep/manager-reps.htm'
import basicController from 'servicestack/basic.controller.properties'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'

class ManagerRepsController {
	constructor($window, $rootScope) { 
		basicController(this)
		let $ctrl = this;
		var url = 'QuerySalesRepYOYTotals.json';
		if ($ctrl.managerId) {
		    url = url + '?ManagerId=' + $ctrl.managerId;
		} else if ($ctrl.repGroup && $ctrl.repGroup != 'ALL') {
		    url = url + '?RepGroupId=' + $ctrl.repGroup;
		}
		$ctrl.reps = new AutoQuery({
		    url: url,
		    pageSize: 15,
		    orderBy: 'Name',
		    autoLoad: true,
		    append: false,
		    sortOptions: {
		        'Id': 'Id: Low to High',
                '-Id': 'Id: High to Low',
		        'Name': 'Name: A to Z',
				'-Name': 'Name: Z to A',
		    },
		    scrollTop: false
		});

	}
}

let ManagerReps = {
	bindings: {
	    managerId: '@',
        repGroup: '@'
	},
	controller: ManagerRepsController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl
	}
}


export default ManagerReps;